import React from "react";

import { Input } from "reactstrap";

import i18next from "../../../../i18n"
import { strUcFirst } from "../../../../utils/index";

interface InputSectionProps {
  value: null | string;
  onChange: (value: string) => void;
}

const InputSection = ({ value, onChange }: InputSectionProps) => {
  // console.log("value",value)
  return (
    <div className="position-relative">
      <Input
        type="text"
        className="form-control form-control-lg chat-input"
        id="chat-input"
        placeholder={strUcFirst(i18next.t('form.type_your_message'))}
        value={value || ""}
        onChange={(e: any) => {
          onChange(e.target.value);
        }}
        autoComplete="off"
      />
    </div>
  );
};
export default InputSection;
